import * as React from "react";
import ViewLoadMore from "../ViewLoadMore";
import ViewLoadedCount from "../ViewLoadedCount";
import { needPagination } from "../utils";
const ViewListFooter = ({ type, files, filesTotal, indexRow, moreLoading, moreFailed, }) => {
    const { pagination } = needPagination({
        type,
        files,
        filesTotal,
    });
    if (!pagination || indexRow > 0)
        return null;
    return (React.createElement("div", { style: {
            flex: 1,
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
        } },
        React.createElement(ViewLoadedCount, { type: type, files: files, filesTotal: filesTotal, style: { margin: "0px 15px" } }),
        React.createElement("div", { style: { flex: 1 } }),
        React.createElement(ViewLoadMore, { type: type, moreLoading: moreLoading, moreFailed: moreFailed, style: { margin: "0px 15px" } })));
};
export default ViewListFooter;
